export const ENDPOINTS = Object.freeze({
  ADDRESSES: 'addresses',
  MEDIA: 'media',
  AUDIOS: 'audios',
  CHANNELS: 'channels',
  COMPENDIA: 'compendia',
  // DOCUMENTATION_FILE: 'http://kbdev.lodgenet.com/cust-help/index.html',
  DOCUMENTATION_FILE: 'https://static.sonifi.com/kb/index.html',
  FILES: 'files',
  GROUPS: 'groups',
  IMAGES: 'images',
  IRD_CATEGORIES: 'ird_categories',
  IRD_ITEMS: 'ird_items',
  IRD_MENUS: 'ird_menus',
  IRD_OPTION_SETS: 'ird_option_sets',
  IRD_ORDERS: 'ird_orders',
  IRD_SETTINGS: 'ird_settings',
  JOBS: 'jobs',
  LAYOUTS: 'layouts',
  MARKETING_IMAGES: 'marketing_images',
  MEDIA_FOLDERS: 'media_folders',
  PERMISSIONS: 'permissions',
  PRODUCT_SETTINGS: 'product_settings',
  PRODUCTS: 'products',
  QRCODES: 'qrcodes',
  REMOTE_CONTROL_ORDERS: 'remote_control_orders',
  REVENUE_CENTERS: 'revenue_centers',
  SAML_DOMAINS: 'saml/domains',
  SAML_SLO: 'saml/slo',
  SCREENS: 'screens',
  SERVICE_CATEGORIES: 'service_categories',
  SERVICE_CENTER_SETTINGS: 'service_center_settings',
  SERVICE_ISSUES: 'service_issues',
  SERVICE_MENUS: 'service_menus',
  SERVICE_ORDERS: 'service_orders',
  SERVICES: 'services',
  SLIDES: 'slides',
  TAGS: 'tags',
  THUMBNAILS: 'thumbnails',
  USERS: 'users',
  VIDEOS: 'videos',
});
